module.exports = __webpack_public_path__ + "img/worker.00350358.png";